import { useState, useEffect } from "react";
import {fetchWithTimeout} from "../utils/fetchWithTimeout";
import Config from "../pages/Config";

export function useShippingFinder(pin, TotalWeight, restricted=false, {length=10, width=10, height=10}={}) {
  const [shippingOptions, setShippingOptions] = useState(null);
  const [shippingOptionsLoading, setShippingOptionsLoading] = useState(true);
  useEffect(()=>{
    if(!pin || pin.length !== 6 || !TotalWeight) return;
    let isActive = true;
    const shippingRate = async()=>{
      const params = new URLSearchParams({
        pickup: 678612,
        target: pin,
        weight: TotalWeight?TotalWeight/1000:0,
        cod: 0,
        length: length,
        breadth: width,
        height: height,
        restricted
      });
      setShippingOptionsLoading(true);
      try{
        const getRate = await fetchWithTimeout(Config.NodePath+"/api/shipping?"+params);

        if(!isActive) return;

        const data = await getRate.json();
        if(data.shippingOptions) {
          const standardOption = data.shippingOptions.filter(option=>option?.name==="Standard");
          const premiumOption = data.shippingOptions.filter(option=>option?.name==="Premium");
          const indiaPostOption = data.shippingOptions.filter(option=>option?.name==="India Post");

          let options = {};
          
          if(standardOption.length===1) {
            options = {...options, standard: standardOption[0]};
          }
          if(premiumOption.length===1) {
            options = {...options, premium: premiumOption[0]};
          }
          if(indiaPostOption.length===1) {
            options = {...options, indiaPost: indiaPostOption[0]};
          }
          setShippingOptions(options);
        }
        else setShippingOptions(null);
      }
      catch(err) {
        console.log(err);
      }
      finally{
        setShippingOptionsLoading(false);
      }
    }
    shippingRate();
    return ()=> {
      isActive = false;
    }
  }, [pin, TotalWeight, restricted, length, width, height]);
  return {shippingOptions, shippingOptionsLoading};
}